export default __webpack_public_path__ + "static/ReadyfortheNewNormal2-f5b1bd3589114f592174ffa582b3ef85.jpg";